import { formatDateForInput } from '../../utils/filters';
import {
    convertDocuments,
    decodeDocuments,
    decodeDocument,
    buildPhoneNumberMaskedInput,
    formatDate,
    trimSpaces,
    fileToBase64
} from '../../utils/utils';

export default {
    async createFromFormData(formData) {
        let request = {
            firstName: formData.firstName,
            lastName: formData.lastName,
            email: formData.email,
            beneficiaryId: formData.beneficiaryId
        };

        if (formData.civility) {
            request.civility = formData.civility;
        }

        if (formData.productCode) {
            request.productCode = formData.productCode;
        }

        if (formData.contractTypeId) {
            request.contractTypeId = formData.contractTypeId;
        }

        if (formData.deadlineDate) {
            request.deadlineDate = formatDate(formData.deadlineDate);
        }

        if (formData.dueDate) {
            request.dueDate = formatDate(formData.dueDate);
        }

        if (formData.guarantyEffectiveDate) {
            request.guarantyEffectiveDate = formatDate(formData.guarantyEffectiveDate);
        }

        if (formData.startDate) {
            request.startDate = formatDate(formData.startDate);
        }

        if (formData.employmentDate) {
            request.employmentDate = formatDate(formData.employmentDate);
        }

        if (null !== formData.dueId) {
            if (null !== formData.oppositeDueId) {
                request.dueId = formData.oppositeDueId
            } else {
                request.dueId = formData.dueId;
            }
        }

        if (formData.phoneNumber) {
            request.phoneNumber = trimSpaces(formData.phoneNumber);
        }

        if (formData.birthName) {
            request.birthName = formData.birthName;
        }

        if (formData.birthDate) {
            request.birthDate = formatDate(formData.birthDate);
        }

        if (formData.employeeNumber) {
            request.employeeNumber = formData.employeeNumber;
        }

        if (formData.externalId) {
            request.externalId = formData.externalId;
        }

        if (
            Number.isInteger(formData.exemptionReason.reasonId)
            && formData.exemptionReason.reasonId !== 0
        ) {
            request.exemptionReason = await this.encodeExemptionReason(formData.exemptionReason);
        }

        return request;
    },
    async createEditRequestFromFormData(formData) {
        let request = {
            email: formData.email,
            beneficiaryId: formData.beneficiaryId
        };

        if (null !== formData.dueId) {
            if (null !== formData.oppositeDueId) {
                request.dueId = formData.oppositeDueId
            } else {
                request.dueId = formData.dueId;
            }
        }

        if (
            Number.isInteger(formData.exemptionReason.reasonId)
            && formData.exemptionReason.reasonId !== 0
        ) {
            request.exemptionReason = await this.encodeExemptionReason(formData.exemptionReason);
        }

        if (formData.exemptionDocument) {
            request.document = {
                typeCode: formData.exemptionDocument.typeCode,
                content: await fileToBase64(formData.exemptionDocument.content)
            };
        }

        return request;
    },
    async createEmployeeEditFormData(exemption) {
        let formData = {
            firstName: exemption.firstName,
            lastName: exemption.lastName,
            email: exemption.email,
            civility: exemption.civility || ''
        };

        if (exemption.beneficiary) {
            formData.beneficiaryId =  exemption.beneficiary.id;
        }

        if (exemption.birthName) {
            formData.birthName = exemption.birthName;
        }

        if (exemption.employeeNumber) {
            formData.employeeNumber = exemption.employeeNumber;
        }

        if (exemption.phoneNumber) {
            formData.phoneNumber = buildPhoneNumberMaskedInput(exemption.phoneNumber);
        }

        if (exemption.birthDate) {
            formData.birthDate = formatDateForInput(exemption.birthDate);
        }

        if (exemption.exemptionReason) {
            formData.exemptionReason = await this.decodeExemptionReason(exemption);
        }

        if (exemption.startDate) {
            formData.startDate = formatDateForInput(exemption.startDate);
        }

        return formData;
    },
    async createEditFormData(exemption) {
        let formData = {
            email: exemption.email,
            beneficiaryId: exemption.beneficiary ? exemption.beneficiary.id : null,
            enterpriseUuid: exemption.enterprise.id
        };

        if (exemption.exemptionReason) {
            formData.exemptionReason = await this.decodeExemptionReason(exemption);
        }

        if (exemption.document) {
            formData.document = await decodeDocument(exemption.document);
        }

        if (exemption.due) {
            formData.dueId = exemption.due.id;
        }

        return formData;
    },
    async createRenewFormData(exemption) {
        let formData = await this.createEmployeeEditFormData(exemption);

        if (exemption.contractType) {
            formData.contractTypeId = exemption.contractType.id;
        }

        if (exemption.dueDate) {
            formData.dueDate = formatDateForInput(exemption.dueDate);
        }

        if (exemption.deadlineDate) {
            formData.deadlineDate = formatDateForInput(exemption.deadlineDate);
        }

        if (exemption.guarantyEffectiveDate) {
            formData.guarantyEffectiveDate = formatDateForInput(exemption.guarantyEffectiveDate);
        }

        if (exemption.employmentDate) {
            formData.employmentDate = formatDateForInput(exemption.employmentDate);
        }

        if (exemption.due) {
            formData.dueId = exemption.due.id;
        }

        return formData;
    },
    async createExemptionForAppreciation(exemption) {
        if (exemption.document) {
            exemption.document = await decodeDocument(exemption.document);
        }

        exemption.exemptionReason = await this.decodeExemptionReason(exemption);

        return exemption;
    },
    async decodeExemptionReason(exemption) {
        let exemptionReason = {
            reasonId: 0,
            documents: [],
            expirationDate: ''
        };

        exemptionReason.reasonId = exemption.exemptionReason.reason.id;
        exemptionReason.documents = await decodeDocuments(
            exemption.exemptionReason.documents
        );

        if (exemption.exemptionReason.expirationDate) {
            exemptionReason.expirationDate = formatDateForInput(
                exemption.exemptionReason.expirationDate
            );
        }

        return exemptionReason;
    },
    async encodeExemptionReason(exemptionReason) {
        let result = {
            reasonId: exemptionReason.reasonId
        };

        result.documents = await convertDocuments(
            exemptionReason.documents
        );

        if (exemptionReason.expirationDate) {
            result.expirationDate = formatDate(exemptionReason.expirationDate);
        }

        return result;
    }
}